import { FC } from 'react'
import { Link } from 'react-router-dom'
import StampImageLink from '../../../../components/stamp-image-link/stamp-image-link'
import { dynamicRoutes } from '../../../../constants/routes'
import { formatRollerDisplay } from '../../../../helpers/format-roller-display'
import Stamp from '../../../../types/api/stamp'

interface StampDetailsProps {
    stamp: Stamp
}

const StampDetails: FC<StampDetailsProps> = ({ stamp }) => (
    <>
        Штамп:{' '}
        <Link
            target='_blank'
            to={dynamicRoutes.equipmentStamp(stamp.documentId || '')}
        >
            {stamp.number || '—'}
        </Link>{' '}
        <StampImageLink stamp={stamp} />
        {' '} Размеры (ШхД): {' '}
        {stamp.width}x{stamp.length}
        {' '} Вал: {' '}
        {formatRollerDisplay(stamp.roller?.roller)}
        {' '} Ручьи: {' '}
        {stamp.floods}
        {' '} Радиус: {' '}
        {stamp.radius}
        {' '} М/э: {' '}
        {stamp.range}
    </>
)

export default StampDetails
